export default [
  {
    path: "/cloud-disk/file",
    name: "cloud-file",
    meta: { title: "文件" },
    component: () =>
      import(/* webpackChunkName: "cloud-file" */ "@/views/cloud-disk/file/index.vue"),
  },
  {
    path: "/cloud-disk/folder-manage",
    name: "folder-manage",
    meta: { title: "文件夹管理" },
    component: () =>
      import(/* webpackChunkName: "cloud-file" */ "@/views/cloud-disk/folder-manage/index.vue"),
  },
  {
    path: "/cloud-disk/share-page/:id",
    name: "share-page",
    meta: { title: "文件预览" },
    component: () =>
      import(/* webpackChunkName: "share-page" */ "@/views/cloud-disk/share-page/index.vue"),
  },
];
